export default __webpack_public_path__ + "static/award-category-bg-min-96df5a3580c80a1c75fe552c548cb8e6.png";